import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { uploadFile } from '../../utils';
import { BASE_URL, getToken } from '../asyncConfig';

export const getAllVehicles = createAsyncThunk(
  'vehicle/getAllVehicles', async (_, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/admin/vehicles`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.vehicles);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const updateVehicleById = createAsyncThunk(
  'vehicle/updateById', async ({id, details}, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.patch(
        `${BASE_URL}/admin/vehicles/${id}`, details,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getVehiclesFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.vehicles = action.payload;
}

export const getVehicleById = createAsyncThunk(
  'vehicle/getVehicleById', async (id, {fulfillWithValue, rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/admin/vehicles/${id}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(res.data.vehicle);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const addVehicle = createAsyncThunk(
  'vehicle/add', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      const res = await uploadFile(details.image, 'vehicles');
      if(!res.success){
        return rejectWithValue(res.response.data);
      }
      const { metadata } = res;
      const { data } = await axios.post(
        `${BASE_URL}/admin/vehicles`, {...details, image: metadata.url},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)